module.exports = __webpack_public_path__ + "img/sukar_yes.4d3ceaad.png";